import { Fragment, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutMain from "../../layouts/LayoutMain";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import SectionTitleMain from "../../components/section-title/SectionTitleMain";
import { useDispatch, useSelector } from "react-redux";
import { fetchWebsiteSections } from "../../store/slices/app-slice";
import CommonBlock from "../../wrappers/block/CommonBlock";
import useLang from "../../hooks/use-lang";
import { useTranslation } from "react-i18next";

const Subscription = () => {
    let { pathname } = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { subscription } = useSelector((state) => state.app);
    const LangUtils = useLang();

    const formattedData = useMemo(() => {
        return subscription.map((data) => ({
            id: data.id,
            title: LangUtils.getLangValue(data, "title"),
            subtitle: LangUtils.getLangValue(data, "subtitle"),
            description: LangUtils.getLangValue(data, "description"),
            button_text: LangUtils.getLangValue(data, "button_text"),
            external_url: data.external_url,
            image_url: data.section_image_1,
        }));
    }, [subscription, LangUtils]);

    useEffect(() => {
        dispatch(fetchWebsiteSections());
    }, [dispatch]);

    return (
        <Fragment>
            <SEO
                titleTemplate={t("subscription__seo_title")}
                description={t("subscription__seo_desc")}
            />
            <LayoutMain headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb
                    pages={[
                        { label: t("home__breadcrumb"), path: process.env.PUBLIC_URL + "/" },
                        {
                            label: t("subscription__breadcrumb"),
                            path: process.env.PUBLIC_URL + pathname,
                        },
                    ]}
                />

                {/* section title with text */}
                <SectionTitleMain
                    spaceTopClass="pt-40"
                    spaceBottomClass="pb-45"
                    titleText={t("subscription__page_title")}
                />

                {formattedData?.map((single, key) => (
                    <div key={key}>
                        <CommonBlock
                            spaceTopClass="pt-50"
                            spaceBottomClass="pb-100"
                            title={single.title}
                            subtitle={single.subtitle}
                            description={single.description}
                            buttonText={single.button_text}
                            externalUrl={single.external_url}
                            imageUrl={single.image_url}
                            imagePosition={key % 2 === 0 ? "left" : "right"}
                        />
                    </div>
                ))}
            </LayoutMain>
        </Fragment>
    );
};

export default Subscription;
